/**
 * @interface
 * @extends {Foundation.View.Interface}
 * @param {jQuerySelector} viewContainer
 */
Foundation.View.Interface.ErrorList = function (viewContainer) {};

Foundation.View.Interface.ErrorList.prototype.clear = function () {};

/**
 * @param {Foundation.Observable} obj
 */
Foundation.View.Interface.ErrorList.prototype.setErrorsFromObservable = function (obj) {};

/* eslint no-unused-vars: "off" */
